import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { PricingSection } from '../components/sections/PricingSection';
import { FooterSection } from '../components/sections/FooterSection';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-284">
      <HeroSection data-id="element-285" />
      <ProblemSection data-id="element-286" />
      <SolutionSection data-id="element-287" />
      <BenefitsSection data-id="element-288" />
      <TestimonialSection data-id="element-289" />
      <AudienceSection data-id="element-290" />
      <HowItWorksSection data-id="element-291" />
      <FAQSection data-id="element-292" />
      <PricingSection data-id="element-293" />
      <FooterSection data-id="element-294" />
    </main>;
}